import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { TopNav } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account creato!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <TopNav />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="label-eyebrow mb-2">Crea la tua rosa</div>
        <h1 className="text-3xl font-black mb-8">Registrati a AstaFantaLive</h1>
        <form onSubmit={submit} className="glass rounded-2xl p-6 space-y-5" data-testid="register-form" autoComplete="off">
          <div>
            <Label htmlFor="name" className="text-slate-300">Nome / Nickname</Label>
            <Input id="name" name="name" data-testid="register-name" autoComplete="off" value={name} onChange={(e) => setName(e.target.value)} required className="mt-2 bg-slate-900/60 border-white/10 h-11" />
          </div>
          <div>
            <Label htmlFor="email" className="text-slate-300">Email</Label>
            <Input id="email" name="email" data-testid="register-email" type="email" autoComplete="off" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 bg-slate-900/60 border-white/10 h-11" />
          </div>
          <div>
            <Label htmlFor="password" className="text-slate-300">Password (min 6 caratteri)</Label>
            <Input id="password" name="password" data-testid="register-password" type="password" minLength={6} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 bg-slate-900/60 border-white/10 h-11" />
          </div>
          <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold">
            {loading ? "Creazione…" : "Crea account"}
          </Button>
          <p className="text-sm text-slate-400 text-center">
            Hai già un account? <Link to="/login" className="text-emerald-400 hover:underline" data-testid="go-login">Accedi</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
